export default __webpack_public_path__ + "static/media/topping_cherry.4d13d192.jpg";